<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="oow-modal"
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <div>
                <animated-info class="mx-auto mb-4"></animated-info>
            </div>
            <h4 class="text-center mb-4">{{$t('bp.OutOfWarranty.title')}}</h4>
            <p class="text-center" :class="{'mb-4': withRedirect}">
              {{$t('bp.OutOfWarranty.text1')}}
            </p>
            <p class="text-center mb-4" v-if="withRedirect">
              {{$t('bp.OutOfWarranty.text2')}}
            </p>
            <p class="text-center">
                <button @click="confirmOow()" class="btn btn-primary btn-lg" :disabled="confirming"><i class="fa fa-spinner fa-pulse" v-if="confirming"></i>{{$t('bp.OutOfWarranty.button')}}</button>
            </p>
        </div>
    </b-modal>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: 'OutOfWarrantyModal',

        props: {
            withRedirect: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                confirming: false
            }
        },

        methods: {
            ...mapActions(['setWarrantyState', 'setWarrantyDetails']),

            confirmOow() {
                this.confirming = true;
                this.setWarrantyState(false).then(() => {
                    this.setWarrantyDetails({purchaseDate: null, imei: null}).then(() => {
                        this.confirming = false;
                        if (this.withRedirect) {
                            this.$router.push({name: 'repairSelect'});
                        } else {
                            this.$bvModal.hide('oow-modal');
                        }
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>